<template>
    <div>
        <select class="form-control"
                :id="id"
                :name="name"
                :placeholder="placeholder"
                :disabled="disabled"
                :required="required"
                :multiple="multiple"></select>
    </div>
</template>

<script>

    // import $ from "jquery";
    // import "select2/dist/js/select2.full";
    // import "select2/dist/css/select2.min.css";

    export default {
        name: "select2",
        data() {
            return {
                select2: null
            };
        },
        model: {
            event: "change",
            prop: "value"
        },
        props: {
            id: {
                type: String,
                default: ""
            },
            name: {
                type: String,
                default: ""
            },
            placeholder: {
                type: String,
                default: ""
            },
            options: {
                type: Array,
                default: () => []
            },
            allowClear: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            settings: {
                type: Object,
                default: () => { }
            },
            value: null
        },
        watch: {
            options(val) {
                this.setOption(val);
            },
            value(val) {
                this.setValue(val);
            }
        },
        methods: {
            setOption(val = []) {
                this.select2.empty();
                let settingsCopy = _.cloneDeep(this.settings)
                this.select2.select2({
                    settingsCopy,
                    data: val
                });
                this.setValue(this.value);
            },
            setValue(val) {
                if (val instanceof Array) {
                    let valCopy = _.cloneDeep(val);
                    this.select2.val(valCopy);
                } else {
                    this.select2.val([val]);
                }
                this.select2.trigger("change");
            }
        },
        mounted() {
            let settingsCopy = _.cloneDeep(this.settings);

            this.select2 = $(this.$el)
                .find("select")
                .select2({
                    settingsCopy,
                    allowClear: this.allowClear,
                    placeholder: this.placeholder,
                    data: this.options
                })
                .val(this.value)
                .trigger('change')
                .on("select2:select", ev => {
                    this.$emit("change", this.select2.val());
                    this.$emit("select", ev["params"]["data"]);
                    this.$emit("input", $(this).val());
                })
                .on("select2:unselect", ev => {
                    if (this.allowClear) {
                        this.$emit("clear");
                    } else {
                        this.$emit("change", this.select2.val());
                        this.$emit("select", ev["params"]["data"]);
                        this.$emit("input", $(this).val());
                    }
                });
            this.setValue(this.value);
        },
        beforeDestroy() {
            this.select2.select2("destroy");
        }
    };
</script>


// WEBPACK FOOTER //
// select2.vue?51335fa1